var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"hm-stage-box"},[(this.value.radio == 0)?_c('div',{staticClass:"hm-stage-box-img"},[_c('SpImage',{staticClass:"pic",attrs:{"src":this.value.img}})],1):_vm._e(),(this.value.radio == 1)?_c('div',{staticClass:"hm-stage-box-video"},[_c('video-player',{attrs:{"options":{
        aspectRatio: _vm.aspectRatio,
        sources: [
          {
            type: 'video/mp4',
            src: _vm.sourceUrl
          }
        ],
        notSupportedMessage: '添加视频源',
        suppressNotSupportedError: true,
        controlBar: false
      }}})],1):_vm._e(),_c('div',{staticClass:"hm-stage-btn"},[_vm._v(" "+_vm._s(_vm.value.cta.desc)+" ")]),_c('div',{staticClass:"hm-stage-title",style:({color: _vm.value.titleData.color})},[_vm._v(" "+_vm._s(_vm.value.titleData.title)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }